if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
          if (this.querySelector('.ws3-gallery-data')) {
      const thumbnails = this.elements.thumbnails;
      thumbnails.enableSliderLooping = true;

      thumbnails.querySelectorAll('button[name]').forEach((button) => {
        button.disabled = false;
      });

      thumbnails.addEventListener('click', (event) => {
        const button = event.target.closest(
          'button[name="previous"], button[name="next"]'
        );
        if (!button) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const items = [...thumbnails.querySelectorAll('[data-target]')]
          .filter((item) => item.clientWidth > 0);

        if (items.length < 2) return;

        const current = Math.max(0, items.findIndex(
          (item) => item.querySelector('[aria-current="true"]')
        ));
        const direction = button.name === 'next' ? 1 : -1;
        const next = (current + direction + items.length) % items.length;

        this.setActiveMedia(items[next].dataset.target, false);
      }, true);
    }
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

        connectedCallback() {
      const dataElement = this.querySelector('.ws3-gallery-data');
      if (!dataElement) return;

      try {
        this.ws3Data = JSON.parse(dataElement.textContent);
        this.ws3ColorIndex = this.ws3Data.options.findIndex(
          (name) => ['color', 'colour', 'farbe'].includes(
            String(name).trim().toLowerCase()
          )
        );
                const activeMedia = this.elements.viewer.querySelector(
          '.is-active[data-media-id]'
        );

        if (activeMedia && this.ws3ColorIndex >= 0) {
          this.setActiveMedia(activeMedia.dataset.mediaId, true);
        }
      } catch (error) {
        console.warn('Galeriedaten konnten nicht gelesen werden.', error);
      }
    } 
        ws3Normalize(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }
    ws3GetMediaColor(media) {
  if (!this.ws3Data || this.ws3ColorIndex < 0) return null;

  const variants = this.ws3Data.variants;
  const mediaList = this.ws3Data.media;
  const colors = [...new Set(
    variants.map((variant) => variant.options[this.ws3ColorIndex])
  )];

  const filenameColor = (item) => {
    const source = item.preview_image?.src || item.src || '';
    const filename = source.split('/').pop().split('?')[0];
    const normalized = '-' + this.ws3Normalize(filename) + '-';
    const matches = colors.filter((color) =>
      normalized.includes('-' + this.ws3Normalize(color) + '-')
    );
    return matches.length === 1 ? matches[0] : null;
  };

  const detectedColor = filenameColor(media);
  if (detectedColor) return detectedColor;

  // Bestehende Dateinamen-Zuordnung bei anderen Produkten beibehalten.
  if (mediaList.some((item) => filenameColor(item))) return null;

  // Jede Farbe muss genau ein eindeutiges Variantenbild besitzen.
  const anchors = [];
  for (const color of colors) {
    const ids = [...new Set(
      variants
        .filter((variant) =>
          variant.options[this.ws3ColorIndex] === color
        )
        .map((variant) => variant.featured_media?.id)
        .filter((id) => id != null)
        .map(String)
    )];

    if (ids.length !== 1) return null;

    const index = mediaList.findIndex((item) =>
      String(item.id) === ids[0]
    );
    if (index < 0) return null;
    anchors.push({ color, index });
  }

  anchors.sort((a, b) => a.index - b.index);
  if (!anchors.length || anchors[0].index !== 0) return null;
  if (new Set(anchors.map((anchor) => anchor.index)).size
      !== anchors.length) return null;

  const index = mediaList.findIndex((item) =>
    String(item.id) === String(media.id)
  );
  if (index < 0) return null;

  return [...anchors].reverse().find((anchor) =>
    anchor.index <= index
  )?.color || null;
}
        ws3FilterMedia(color) {
      if (!this.ws3Data || this.ws3ColorIndex < 0) return false;

      const matchingIds = this.ws3Data.media
        .filter((media) => this.ws3GetMediaColor(media) === color)
        .map((media) => String(media.id));

      if (!matchingIds.length) return false;

      this.querySelectorAll('[data-media-id], [data-target]')
        .forEach((element) => {
          const key = element.dataset.mediaId || element.dataset.target;
          const mediaId = key.split('-').pop();
          const visible = matchingIds.includes(mediaId);

          if (visible) {
            element.classList.remove(
              'product__media-item--variant',
              'thumbnail-list_item--variant'
            );
            element.style.removeProperty('display');
          } else {
            element.style.setProperty('display', 'none', 'important');
          }
        });

      this.elements.viewer.resetPages?.();
      this.elements.thumbnails?.resetPages?.();

      return true;
    }
    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
            if (prepend && this.ws3Data && this.ws3ColorIndex >= 0) {
        const id = String(mediaId).split('-').pop();
        const media = this.ws3Data.media.find(
          (item) => String(item.id) === id
        );
        const color = media ? this.ws3GetMediaColor(media) : null;

        if (color) {
          this.ws3FilterMedia(color);
        } else {
          this.querySelectorAll('[data-media-id], [data-target]')
            .forEach((element) => {
              element.style.removeProperty('display');
            });
        }
      }
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          // disable changing position of gallery thumbnails
          // activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
